import * as React from 'react';
import { SVGProps } from 'react';

const SendMessageicon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="m8.755 12.149 1.771 7.969c.221.993 1.54 1.207 2.063.335l8.25-13.749A1.124 1.124 0 0 0 19.873 5H4.324C3.32 5 2.817 6.212 3.526 6.921l5.228 5.228ZM20.84 5.56 8.75 12.15" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SendMessageicon;
